import {
  _emLeadsData,
  _ownLead,
  _withdrawLead,
  _changeFaqData,
  _loadMoreData,
} from "../actions/types";

const initialState = {
  emLeadsData: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case _emLeadsData:
      return {
        ...state,
        emLeadsData: action.payload,
      };

    case _withdrawLead:
      var objIndex = state.emLeadsData.overAllleads.leads.findIndex((obj => obj.demo_id == action.payload));
      state.emLeadsData.overAllleads.leads[objIndex].demo_status = 1;
      debugger;
      var faq_data = state.emLeadsData.myLeads.faq_data;
      delete faq_data[action.payload]; //for delete faq data
      var myLeads = { ...state.emLeadsData.myLeads.myLeads };
      delete myLeads[action.payload];
      var myLeads = {
        faq_data,
        myLeads,
        myLeadsCount: state.emLeadsData.myLeads.myLeadsCount - 1,
      };
      return {
        ...state,
        emLeadsData: {
          ...state.emLeadsData,
          myLeads,
        },
      };

    case _ownLead:
      var myLeads = {
        ...state.emLeadsData.myLeads.myLeads,
        [action.payload]: 1136,
      };
      var objIndex = state.emLeadsData.overAllleads.leads.findIndex((obj => obj.demo_id == action.payload));
      state.emLeadsData.overAllleads.leads[objIndex].demo_status = 2;
      debugger;
      var faq_data = state.emLeadsData.myLeads.faq_data;
      var myLeads = {
        faq_data,
        myLeads,
        myLeadsCount: state.emLeadsData.myLeads.myLeadsCount + 1,
      };
      console.log("Lead Print", myLeads);
      return {
        ...state,
        emLeadsData: {
          ...state.emLeadsData,
          myLeads,
        },
      };

    case _changeFaqData:
      var myLeads = {
        ...state.emLeadsData.myLeads.myLeads,
        [action.payload]: 1136,
      };
      var faq_data = { [action.id]: JSON.stringify(action.payload) };
      var myLeads = {
        faq_data,
        myLeads,
        myLeadsCount: state.emLeadsData.myLeads.myLeadsCount,
      };
      console.log("Struction Print", myLeads);
      return {
        ...state,
        emLeadsData: {
          ...state.emLeadsData,
          myLeads,
        },
      };

    case _loadMoreData:
      var leads = [];

      var stateData = state.emLeadsData.overAllleads.leads;
      var apiData = action.payload.overAllleads.leads;
      leads.push(...stateData, ...apiData);

      var overAllleads = {
        leads,
        leadsCount: state.emLeadsData.overAllleads.leadsCount,
      };
      return {
        ...state,
        emLeadsData: {
          ...state.emLeadsData,
          overAllleads,
        },
      };

    default:
      return state;
  }
}
